function d(e) {
  return typeof e == "string";
}
function T(e) {
  return Number.isInteger(e);
}
function J(e) {
  return Array.isArray(e);
}
function k(e) {
  return typeof e == "object" && !J(e) && !w(e);
}
function M(e) {
  return typeof e > "u";
}
function w(e) {
  return e === null;
}
function o(e) {
  return !(M(e) || w(e));
}
function A(e) {
  return !o(e);
}
function D(...e) {
  throw new Error(e.join(""));
}
function E() {
}
function I() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
I();
const P = "(\\d{4})\\D(\\d{1,2})\\D(\\d{1,2})", O = "(\\d{1,2})\\D(\\d{2})\\D(\\d{2})", _ = `^\\s*${P}(?:(?:T|\\s)${O})?`, j = new RegExp(_), b = [void 0, "year", "month", "day", "hours", "minutes", "seconds"], v = ["year", "month", "day", "hour", "minute", "second"], R = { hour: "hours", minute: "minutes", second: "seconds" }, l = {
  joint: " ",
  dateJoint: "-",
  timeJoint: ":",
  locale: "default"
};
class u {
  /**
   * Constructor for Timestamp object.
   * @param {string|number|Date|Object} [ts] - timestamp
   * @param {Object} [options] - configuration options
   * @param {string} [options.joint=' '] - joining character between date and time parts
   * @param {string} [options.dateJoint='-'] - joining character for date segments
   * @param {string} [options.timeJoint=':'] - joining character for time segments
   * @param {string} [options.locale='default'] - locale for formatting dates and times
   */
  constructor(t, s) {
    const r = { ...l, ...s };
    this.props = r, this.debug = r.debug ? console.log.bind(console) : E, A(t) ? this.parts = x() : t instanceof u ? this.parts = { ...t.parts } : N(t) ? this.parts = $(t) : d(t) ? this.parts = m(t) : q(t) ? this.parts = f(t) : T(t) ? this.parts = m(t) : k(t) ? o(t.unix) ? this.parts = m(t.unix * 1e3) : o(t.ms) ? this.parts = m(t.ms) : this.parts = t : D(`Invalid timestamp: ${t}`);
  }
  /**
   * Method to return a new object as a copy of the current object
   * @return {Timestamp} - new `Timestamp` object
   */
  copy() {
    return new u(this.parts);
  }
  //--------------------------------------------------------------------------
  // Methods to set/get constituent parts
  //--------------------------------------------------------------------------
  /**
   * Method to get or set the year.
   * @param {number} [year] - optional new value for year
   * @return {number} - the year
   */
  year(t) {
    return o(t) && (this.parts.year = t), this.parts.year;
  }
  /**
   * Method to get or set the month.
   * @param {number} [month] - optional new value for month
   * @return {number} - the month
   */
  month(t) {
    return o(t) && (this.parts.month = t, this.correct()), this.parts.month;
  }
  /**
   * Method to get or set the day.
   * @param {number} [day] - optional new value for day
   * @return {number} - the day
   */
  day(t) {
    return o(t) && (this.parts.day = t, this.correct()), this.parts.day;
  }
  /**
   * Method to get or set the hours.
   * @param {number} [hours] - optional new value for hours
   * @return {number} - the hours
   */
  hours(t) {
    return o(t) && (this.parts.hours = t, this.correct()), this.parts.hours;
  }
  /**
   * Method to get or set the minutes.
   * @param {number} [minutes] - optional new value for minutes
   * @return {number} - the minutes
   */
  minutes(t) {
    return o(t) && (this.parts.minutes = t, this.correct()), this.parts.minutes;
  }
  /**
   * Method to get or set the seconds.
   * @param {number} [seconds] - optional new value for seconds
   * @return {number} - the seconds
   */
  seconds(t) {
    return o(t) && (this.parts.seconds = t, this.correct()), this.parts.seconds;
  }
  //--------------------------------------------------------------------------
  // Conversion to other formats
  //--------------------------------------------------------------------------
  /**
   * Method to return a `Date` object
   * @return {Date} - new date object
   */
  dateObject() {
    return new Date(
      this.stamp({ joint: "T", dateJoint: "-", timeJoint: ":" })
    );
  }
  /**
   * Method to return the number of millseconds since the Unix epoch
   * @return {number} - the number of milliseconds
   */
  epochMilliseconds() {
    return this.dateObject().getTime();
  }
  /**
   * Method to return the number of seconds since the Unix epoch
   * @return {number} - the number of seconds
   */
  epochSeconds() {
    return Math.floor(this.epochMilliseconds() / 1e3);
  }
  //--------------------------------------------------------------------------
  // Formatting
  //--------------------------------------------------------------------------
  /**
   * Method to return a formatted timestamp string in the form `YYYY-MM-DD HH:MM:SS`.
   * @param {Object} [options] - configuration options
   * @param {string} [options.joint=' '] - joining character between date and time parts
   * @param {string} [options.dateJoint='-'] - joining character for date segments
   * @param {string} [options.timeJoint=':'] - joining character for time segments
   * @return {string} - formatted date/time stamp
   */
  stamp(t = {}) {
    return h(
      this.parts,
      { ...this.props, ...t }
    );
  }
  /**
   * Auto-stringification method as a wrapper around {@link stamp()}.
   * @param {Object} [options] - configuration options
   * @param {string} [options.joint=' '] - joining character between date and time parts
   * @param {string} [options.dateJoint='-'] - joining character for date segments
   * @param {string} [options.timeJoint=':'] - joining character for time segments
   * @return {string} - formatted date/time stamp
   */
  toString(t) {
    return this.stamp(t);
  }
  /**
   * Method to return a formatted date string in the form `YYYY-MM-DD`.
   * @param {string} [joint='-'] - optional joining character
   * @return {string} - formatted date string
   */
  date(t = this.props.dateJoint) {
    return c(this.parts, t);
  }
  /**
   * Method to return a formatted time string in the form `HH:MM:SS`.
   * @param {string} [joint=':''] - optional joining character
   * @return {string} - formatted time string
   */
  time(t = this.props.timeJoint) {
    return p(this.parts, t);
  }
  /**
   * Method to return the timestamp in kebab-case `YYYY-MM-DD-hh-mm-ss` regardless of any options.
   * @return {string} - formatted date/time string
   */
  kebab() {
    return h(
      this.parts,
      { joint: "-", dateJoint: "-", timeJoint: "-" }
    );
  }
  /**
   * Method to return the date and time in kebab-case `YYYYMMDD-hhmmss` regardless of any options.
   * @return {string} - formatted date/time string
   */
  kebabDateTime() {
    return h(
      this.parts,
      { joint: "-", dateJoint: "", timeJoint: "" }
    );
  }
  /**
   * Method to return the date in kebab-case `YYYY-MM-DD` regardless of any options.
   * @return {string} - formatted date string
   */
  kebabDate() {
    return c(this.parts, "-");
  }
  /**
   * Method to return the time in kebab-case `hh-mm-ss` regardless of any options.
   * @return {string} - formatted time string
   */
  kebabTime() {
    return p(this.parts, "-");
  }
  /**
   * Method to return the timestamp in snake-case `YYYY_MM_DD_hh_mm_ss` regardless of any options.
   * @return {string} - formatted date/time string
   */
  snake() {
    return h(
      this.parts,
      { joint: "_", dateJoint: "_", timeJoint: "_" }
    );
  }
  /**
   * Method to return the date and time in snake-case `YYYYMMDD_hhmmss` regardless of any options.
   * @return {string} - formatted date/time string
   */
  snakeDateTime() {
    return h(
      this.parts,
      { joint: "_", dateJoint: "", timeJoint: "" }
    );
  }
  /**
   * Method to return the date in snake-case `YYYY_MM_DD` regardless of any options.
   * @return {string} - formatted date string
   */
  snakeDate() {
    return c(this.parts, "_");
  }
  /**
   * Method to return the time in snake-case `hh_mm_ss` regardless of any options.
   * @return {string} - formatted time string
   */
  snakeTime() {
    return p(this.parts, "_");
  }
  /**
   * Method to return the timestamp squished together as `YYYYMMDDhhmmss` regardless of any options.
   * @return {string} - formatted date/time string
   */
  squish() {
    return h(
      this.parts,
      { joint: "", dateJoint: "", timeJoint: "" }
    );
  }
  /**
   * Method to return the date squished together as `YYYYMMDD` regardless of any options.
   * @return {string} - formatted date string
   */
  squishDate() {
    return c(this.parts, "");
  }
  /**
   * Method to return the time squished together as `hhmmss` regardless of any options.
   * @return {string} - formatted time string
   */
  squishTime() {
    return p(this.parts, "");
  }
  /**
   * Method to return the month name.
   * @param {string} [format='long'] - optional format: `full`, `long`, `medium`, `short`
   * @return {string} - the month name
   */
  monthName(t = "long") {
    const s = this.dateObject().toLocaleString(
      this.props.locale,
      { month: t }
    );
    return t === "short" ? s.slice(0, 3) : s;
  }
  /**
   * Method to return the weekday name as a number from 0 (Sunday) to 6 (Saturday)
   * @return {number} - the weekday number
   */
  weekday() {
    return this.dateObject().getDay();
  }
  /**
   * Method to return the weekday name.
   * @param {string} [format='long'] - optional format: `full`, `long`, `medium`, `short`
   * @return {string} - the weekday name
   */
  weekdayName(t = "long") {
    return this.dateObject().toLocaleString(
      this.props.locale,
      { weekday: t }
    );
  }
  //--------------------------------------------------------------------------
  // Adjustment
  //--------------------------------------------------------------------------
  /**
   * Method to adjust the timestamp.  The duration can be specified as a string containing
   * one or more items to adjust in either singular or plural form, e.g. `"1 year, 1 month"`,
   * `"2 years 2 months"`, etc. Or it can be specified as an object: `{ year: 1, month: 1 }`,
   * `{ years: 2, months: 2 }`, etc.  Any overflow or underflow will be corrected by the
   * {@link correct()} method.
   * @param {string|Object} duration - a string or object of adjustments
   * @example
   * ts.adjust("1 year 2 months 3 hours")
   * @example
   * ts.adjust({ year: 1, months: 2, hours: 3 })
   */
  adjust(t) {
    const s = this.parts, r = d(t) ? B(t) : H(t);
    return v.forEach(
      (n) => {
        const a = r[n];
        o(a) && (s[R[n] || n] += a);
      }
    ), this.correct();
  }
  /**
   * Method to correct any underflow or overflow in the timestamp.  For example, if the
   * month is set to 13 then it will be set to 1 and the year will be incremented.
   */
  correct() {
    const t = this.parts;
    for (; t.seconds < 0; )
      t.seconds += 60, t.minutes--;
    for (; t.minutes < 0; )
      t.minutes += 60, t.hours--;
    for (; t.hours < 0; )
      t.hours += 24, t.day--;
    for (t.seconds > 59 && (t.minutes += Math.floor(t.seconds / 60), t.seconds %= 60), t.minutes > 59 && (t.hours += Math.floor(t.minutes / 60), t.minutes %= 60), t.hours > 23 && (t.day += Math.floor(t.hours / 24), t.hours %= 24); t.day <= 0; )
      t.month--, t.month <= 0 && (t.month += 12, t.year--), t.day += y(t.month, t.year);
    for (; t.month <= 0; )
      t.month += 12, t.year--;
    for (; t.month > 12; )
      t.month -= 12, t.year++;
    let s;
    for (; t.day > (s = y(t.month, t.year)); )
      t.day -= s, t.month == 12 ? (t.month = 1, t.year++) : t.month++;
    return this;
  }
  //--------------------------------------------------------------------------
  // Comparison
  //--------------------------------------------------------------------------
  /**
   * Method to compare the timestamp to another.  The arguments can be any that are accepted
   * by the constructor.
   * one or more items to adjust in either singular or plural form, e.g. `"1 year, 1 month"`,
   * `"2 years 2 months"`, etc. Or it can be specified as an object: `{ year: 1, month: 1 }`,
   * `{ years: 2, months: 2 }`, etc.
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {Comparison} - -1 if the timestamp is before the comparator, 0 if it's equal, +1 if it's after.
   */
  compare(t, s) {
    const r = new u(t, s), n = this.parts, a = r.parts;
    for (const i of b)
      if (i) {
        if (n[i] < a[i])
          return this.debug("[%s] this[%s] < that[%s]", i, n[i], a[i]), -1;
        if (n[i] > a[i])
          return this.debug("[%s] this[%s] > that[%s]", i, n[i], a[i]), 1;
        this.debug("[%s] this[%s] = that[%s]", i, n[i], a[i]);
      }
    return 0;
  }
  /**
   * Method to compare one timestamp to another for equality
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {boolean} - true if the timestamp is equal to the operand
   */
  equal(t, s) {
    return this.compare(t, s) == 0;
  }
  /**
   * Method to test for the timestamp coming before another timestamp
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {boolean} - true if the timestamp is before the operand
   */
  before(t, s) {
    return this.compare(t, s) == -1;
  }
  /**
   * Method to test for the timestamp coming after another timestamp
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {boolean} - true if the timestamp is after the operand
   */
  after(t, s) {
    return this.compare(t, s) == 1;
  }
  /**
   * Method to test for the timestamp being equal to or coming after another timestamp
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {boolean} - true if the timestamp is equal to or coming after the operand
   */
  notBefore(t, s) {
    return this.compare(t, s) >= 0;
  }
  /**
   * Method to test for the timestamp being equal to or coming before another timestamp
   * @param {TimestampSource} ts - any argument accepted by the constructor
   * @param {TimestampOptions} options - additional configuration options
   * @return {boolean} - true if the timestamp is equal to or coming before the operand
   */
  notAfter(t, s) {
    return this.compare(t, s) <= 0;
  }
  /**
   * Method to test for the timestamp being in the past.
   * @return {boolean} - true if the timestamp is before the current time
   */
  inThePast() {
    return this.before(g());
  }
  /**
   * Method to test for the timestamp being in the past.
   * @return {boolean} - true if the timestamp is before the current time
   */
  inTheFuture() {
    return this.after(g());
  }
}
const N = (e) => d(e) && !!e.match(j), $ = (e) => {
  const t = e.match(j) || D("Invalid timestamp: ", e), s = {
    year: 0,
    month: 0,
    day: 0
  };
  return b.forEach(
    (r, n) => {
      r && t[n] && (s[r] = parseInt(t[n]));
    }
  ), s;
}, q = (e) => e instanceof Date, x = () => f(/* @__PURE__ */ new Date()), m = (e) => f(new Date(e)), f = (e) => ({
  year: e.getFullYear(),
  month: e.getMonth() + 1,
  day: e.getDate(),
  hours: e.getHours(),
  minutes: e.getMinutes(),
  seconds: e.getSeconds()
}), B = (e) => {
  const t = e.matchAll(/(-?\d+)\s*(\w+)/g), s = {};
  for (const r of t) {
    const n = parseInt(r[1]), a = r[2].replace(/s$/, "");
    s[a] = n;
  }
  return S(s);
}, H = (e) => {
  const t = {};
  return Object.entries(e).forEach(
    ([s, r]) => {
      t[s.replace(/s$/, "")] = r;
    }
  ), S(t);
}, S = (e) => (e.week && (e.day = (e.day || 0) + e.week * 7, delete e.week), e), h = (e, t = {}) => {
  const s = c(e, t.dateJoint);
  if (o(e.hours)) {
    const r = p(e, t.timeJoint);
    return [s, r].join(
      o(t.joint) ? t.joint : l.joint
    );
  } else
    return s;
}, c = (e, t = l.dateJoint) => [
  String(e.year).padStart(4, "0"),
  String(e.month).padStart(2, "0"),
  String(e.day).padStart(2, "0")
].join(t), p = (e, t = l.timeJoint) => o(e.hours) ? [
  String(e.hours).padStart(2, "0"),
  String(e.minutes).padStart(2, "0"),
  String(e.seconds).padStart(2, "0")
].join(t) : void 0, y = (e, t) => e === 4 || e === 6 || e === 9 || e === 11 ? 30 : e == 2 ? L(t) ? 29 : 28 : 31, L = (e) => e % 4 ? !1 : e % 400 === 0 ? !0 : e % 100 !== 0, C = (e, t) => new u(e, t), g = (e) => new u(null, e);
export {
  u as Timestamp,
  y as daysInMonth,
  q as isDate,
  N as isTimestamp,
  c as joinDate,
  p as joinTime,
  h as joinTimestamp,
  L as leapYear,
  g as now,
  m as parseDate,
  B as parseDuration,
  H as singularDurations,
  $ as splitTimestamp,
  C as timestamp,
  f as unpackDate,
  x as unpackNow,
  S as weeksToDays
};
//# sourceMappingURL=badger-timestamp.js.map
